module.exports = __webpack_public_path__ + "static/media/login-icon-red.f760f699.svg";